/*!**************************Confidential and Proprietary*****************************
* File Name: Models.ts
********************Copyright (c) Hyland Software, Inc. 1992-2023********************/

export class DataChartModel {
    public chartType: CHART_TYPE;
    public data: any;
    public instanceID: any;
    public displayLabels: boolean;
    public displayLegend: boolean;
    public title: string;
    public token: string;
    public methods: Methods;
    public strings: Strings;
}

export class Methods {
    public itemClicked: any;
    public onLoad: any;
}

class Strings {
    STR_RC_OTHERS: 'Others';
}

export enum CHART_TYPE {
    None = -1,
    Grid = 0,
    Pie = 1,
    Bar = 2,
    HorizontalBar = 3
};
